import React, { useState, useEffect } from 'react';

const locales = ['en', 'sv', 'nb', 'es'];

const LanguageSwitch = ({ displayLanguage = 'en', onChange = () => {} }) => {

  const handleToggle = (locale) => {
    displayLanguage = locale;
    onChange && onChange(locale);
  };

  return (
    <div className='language-container'>
      <div className='language-container-list'>
        { locales.map( locale => 
          <div key={locale} className={`language-container-list-item pointer ${ displayLanguage === locale ? 'selected' : ''}`} onClick={() => handleToggle(locale)}>
            {locale}
          </div>
        )}
        
      </div>
    </div>
  );
};

export default LanguageSwitch;
